import { Money, TransactionType } from 'types';
import { toDisplayDateFormat } from 'lib/utils/date';
import { LineItem } from 'components/payments/primitives/index';

export interface CreditVoucherLineItemProps {
  type: TransactionType;
  createdAt: string | Date;
  voucherCode: string;
  total: Money;
}

const CreditVoucherLineItem = ({ type, createdAt, voucherCode, total }: CreditVoucherLineItemProps) => (
  <LineItem title="Credit voucher" totals={[total]}>
    {type === 'REFUND'
      ? `Refunded on ${toDisplayDateFormat(createdAt)} to credit voucher ending ${voucherCode}`
      : `Redeemed on ${toDisplayDateFormat(createdAt)} using credit voucher ending ${voucherCode}`}
  </LineItem>
);

export default CreditVoucherLineItem;
